import MetaDataCategoryIndex from '@pages/meta-data-categories/MetaDataCategoryIndex'
import { beforeRouteEnterAction } from '@router/router.utils'

export default [
  {
    path: '/meta-data-categories',
    name: 'meta-data-categories',
    component: MetaDataCategoryIndex,
    meta: {
      requiresAuth: true,
      actions: ['metaDataCategories/getAll'],
      pageTitle: 'Metadata Categories',
      pathToLocalization: 'metaDataCategories.title'
    },
    beforeEnter: beforeRouteEnterAction
  }
]
